import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassUserRating extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'CompassUserRating'
  // Define default properties here
  static instanceDefaults () {
    return {
      title: null,
      isHighlighted: false,
      compassId: null,
      userId: null,
      guestUserId: null,
      compass_categories_ratings: null,
    }
  }
}
const servicePath = 'compass-user-ratings'
const servicePlugin = makeServicePlugin({
  Model: CompassUserRating,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
